<template>
  <div>
    <div class="position-relative dinA4">
      <img :src="require('@/assets/other-considerations-header.png')" class="page__header" />
      <div class="page__container">
        <p class="body-2 justify-text body-2--bold mt-0 mb-0">Pesos y medidas.</p>
        <p class="body-2 justify-text mt-1 mb-0">
          Limitación máxima para envíos transportados por la red:
        </p>

        <p class="body-2 justify-text body-2--bold mt-4 mb-0">Peso máximo por bulto: 30 kg.</p>
        <p class="body-2 justify-text mt-1 mb-0">Exceso de peso por bulto:</p>
        <ul class="list-style-none body-2 justify-text mt-1 mb-0">
          <li class="pl-4">
            - Se aplicará un suplemento de
            {{ getAdditionalServiceById('EXC_PESO_40').value }}
            <span class="euro-symbol">€</span>
            en aquellos bultos que pesen más de 30 kg por bulto expedido hasta 70 kg.
          </li>
          <li class="pl-4">
            - Se aplicará un suplemento de
            {{ getAdditionalServiceById('EXP_PESO_70').value }}
            <span class="euro-symbol">€</span>
            en aquellos bultos que pesen más de 70 kg por bulto expedido hasta 300 kg.
          </li>
          <li class="pl-4">
            - Se aplicará un suplemento de
            {{ getAdditionalServiceById('SUPL_EXC_BULTO_KILO_ADIC').value }}
            <span class="euro-symbol">€</span>
            por kg adicional en aquellos bultos que pesen más de 300 kg por bulto expedido.
          </li>
        </ul>
        <p class="body-2 justify-text mt-1 mb-0">
          Nota: El adeudo de exceso de peso se aplica sólo sobre el peso de báscula y no del
          volumétrico.
        </p>

        <p class="body-2 justify-text mt-4 mb-0">
          <b>Medida máxima por bulto:</b> Suma de alto, ancho y largo del bulto no superior a 240
          cm, con ninguna dimensión superior a 150 cm.
        </p>
        <p class="body-2 justify-text mt-0 mb-0">Exceso de medidas:</p>
        <ul class="list-style-none body-2 justify-text">
          <li class="pl-4">
            - Se aplicará un suplemento de
            {{ getAdditionalServiceById('EXP_MEDIDAS_240').value }}
            <span class="euro-symbol">€</span>
            en aquellos bultos que la suma de alto, ancho y largo del bulto sea de 240 cm hasta 300
            cm.
          </li>
          <li class="pl-4">
            - Se aplicará un suplemento de
            {{ getAdditionalServiceById('SUPL_EXC_MEDIDAS_300').value }}
            <span class="euro-symbol">€</span>
            por cada 10 cm de exceso en aquellos bultos que la suma de alto, ancho y largo del bulto
            supere los 300 cm.
          </li>
        </ul>

        <p class="body-2 justify-text mt-4 mb-0">
          <b>Medidas de uno de los lados:</b> Ninguna dimensión superior a 150 cm.
        </p>
        <p class="body-2 justify-text mt-0 mb-0">Exceso de medidas:</p>
        <ul class="list-style-none body-2 justify-text">
          <li class="pl-4">
            - Se aplicará un suplemento de
            {{ getAdditionalServiceById('EXP_MEDIDAS_150').value }}
            <span class="euro-symbol">€</span>
            cuando cualquiera de las medidas supere la dimensión de los 150 cm hasta 200 cm.
          </li>
          <li class="pl-4">
            - Se aplicará un suplemento de
            {{ getAdditionalServiceById('EXP_MEDIDAS_200').value }}
            <span class="euro-symbol">€</span>
            cuando cualquiera de las medidas supere la dimensión de los 200 cm hasta 240 cm.
          </li>
          <li class="pl-4">
            - Se aplicará un suplemento de
            {{ getAdditionalServiceById('SUPL_EXC_MEDIDAS_240').value }}
            <span class="euro-symbol">€</span>
            por cada 10 cm de exceso cuando cualquiera de las medidas supere la dimensión de los 240
            cm.
          </li>
        </ul>
        <p class="body-2 justify-text mt-1 mb-0">
          Importante: Para los bultos de más de 300 kg y las medidas máximas, suma de medidas a
          partir de 300cm y medida máxima de uno de los lados a partir de 240 cm, CTT Express se
          reserva el derecho de admitir o no esta mercancía.
        </p>
        <p class="body-2 justify-text mt-1 mb-0">
          Nota: Los servicios 10:00, Baleares, Canarias, Otros Destinos no Peninsulares y Puntos de
          Collect Express (*), NO admiten excesos de peso ni excesos de medidas máximas.
        </p>
        <p class="body-2 justify-text mt-0 mb-0">
          (*) Para otras limitaciones en puntos de Collect Express consultar con tu comercial.
        </p>
        <p class="body-2 justify-text mt-1 mb-2">
          Los adeudos son acumulativos entre diferentes categorías, es decir, se podrá cobrar un
          exceso de peso, un exceso de medidas sobre el sumatorio total y un exceso de medidas sobre
          una dimensión.
        </p>
        <p class="body-2 justify-text mt-1 mb-0">
          Aclaración de los diferentes pesos aplicados:
        </p>
        <p class="body-2 justify-text mt-1 mb-0">
          Peso real (báscula): Se construye a partir de las lecturas del peso físico de los
          sorter (clasificadores automáticos) o básculas manuales, seleccionando la mayor de
          todas y que estén disponibles en el sistema para cada uno de los bultos que
          conforman una expedición. Siempre serán lecturas de los sorter o básculas de la
          máster y en ningún caso se incluyen pesajes de clientes.
        </p>
        <p class="body-2 justify-text mt-1 mb-0">
          Peso volumétrico: Se calcula multiplicando las medidas largo (cm) x ancho (cm) x
          alto (cm), identificadas en la lectura de cada bulto por el factor de conversión
          volumétrica asociado a cada producto. El peso volumétrico final es la suma
          individual del peso volumétrico de los bultos que constituyen la expedición.
        </p>
        <p class="body-2 justify-text mt-1 mb-0">
          Peso informado: Se trata de la información que el cliente nos transmite, bien de
          peso o de medidas y que él calcula con sus propios medios.
        </p>
        <p class="body-2 justify-text mt-1 mb-0">
          Peso facturado: El mayor en kilos entre el peso real (báscula) y el volumétrico
          (aplicando el factor asociado a condiciones específicas del cliente). De no existir
          alguno de los dos pesos se incorporaría el peso informado. El factor de conversión
          volumétrica estará asociado al producto a facturar y las condiciones del cliente
          para ese producto.
        </p>
        <template v-if="this.getAdditionalServiceById('OTP').value !== undefined">
          <p class="body-2 justify-text body-2--bold mt-4 mb-0">Servicio de Entrega con OTP (One Time Password):</p>
          <p class="body-2 justify-text mt-1 mb-0">
            Garantiza a través de un código PIN la entrega al destinatario final. A todos los envíos con servicio de OTP
            se les aplicará un suplemento de {{ getAdditionalServiceById('OTP').value }}€. Los envíos con entrega OTP,
            igualmente te permite (bajo autorización
            del cliente) que en caso de que el destinatario poseedor del código PIN no se encuentre en el domicilio de
            entrega, esta se realice a otra persona diferente del destinatario que se encuentre en el domicilio,
            realizando por parte del repartidor una verificación fehaciente del DNI, número de DNI y firma de este
            tercero
            a quien se realiza la entrega. Las entregas en Portugal se realizarán siempre con OTP o en su defecto DNI.
          </p>
        </template>
        <p class="body-2 justify-text body-2--bold mt-4 mb-0">Envíos Multibulto.</p>
        <p class="body-2 justify-text mt-1 mb-0">
          Las expediciones que superen los 5 bultos tendrán un suplemento de
          {{ getAdditionalServiceById('SUPL_EXP_MULTIBULTO').value }}
          <span class="euro-symbol">€</span>
          por bulto adicional a partir del sexto bulto y hasta un límite máximo de 20 bultos por expedición. A partir de dicha cantidad, CTT Express se reserva el derecho de admitir o rechazar los envíos que superen los 20 bultos por expedición.
        </p>





      </div>

      <Footer logo :page="previousPages + 1" />
    </div>

    <div class="position-relative dinA4">
      <img :src="require('@/assets/other-considerations-header.png')" class="page__header" />
      <div class="page__container">
        <p class="body-2 justify-text body-2--bold mt-0 mb-0">Envíos Irregulares.</p>
        <p class="body-2 justify-text mt-1 mb-0">
          Se aplicará un suplemento de
          {{ getAdditionalServiceById('SUPL_IRREGULARES').value }}
          <span class="euro-symbol">€</span>
          aquellos bultos cuyas medidas máximas superen:
        </p>
        <ul class="list-style-none body-2 justify-text">
          <li class="pl-4">
            - 120 cm en la primera medida mayor y la segunda medida mayor supere los 80 cm.
          </li>
          <li class="pl-4">
            - Y/o presenten inestabilidad en cualquiera de sus caras no pudiéndose apilar
            verticalmente.
          </li>
        </ul>

        <p class="body-2 justify-text body-2--bold mt-4 mb-0">Envíos soporte palets</p>
        <p class="body-2 justify-text mt-1 mb-0">
          En caso de envíos con soporte palets, la altura mínima facturable será de 1.50m.
        </p>
        <p class="body-2 justify-text body-2--bold mt-4 mb-0">
          Recogidas fallidas en España y Portugal.
        </p>
        <p class="body-2 justify-text mt-1 mb-0">
          Se facturará
          {{ getAdditionalServiceById('REC_FALLIDA').value }}
          <span class="euro-symbol">€</span>
          por cada recogida fallida en España y
          {{ getAdditionalServiceById('REC_FALLIDA_PT').value }}
          <span class="euro-symbol">€</span>
          por cada recogida fallida en Portugal por motivos imputables al cliente. Se entenderá como
          motivo imputable al cliente todas aquellas recogidas que no se puedan realizar por las
          siguientes causas.
        </p>
        <ul class="list-style-none body-2 justify-text">
          <li class="pl-4">- El cliente no tiene preparada o no tiene mercancía para recoger.</li>
          <li class="pl-4">
            - La dirección facilitada por el cliente está incompleta o incorrecta.
          </li>
          <li class="pl-4">
            - La persona de contacto facilitada por el cliente en la recogida está ausente o no
            responde.
          </li>
        </ul>
        <p class="body-2 justify-text body-2--bold mt-4 mb-0">
          Recogidas realizadas en Domicilios diferentes al punto de recogida habitual (Intercity).
        </p>
        <p class="body-2 justify-text mt-1 mb-0">
          Las recogidas se podrán realizar en un domicilio diferente al consignado como "Dirección
          del punto de recogida habitual".
        </p>
        <ul class="list-style-none body-2 justify-text">
          <li class="pl-4">
            - Sin coste alguno por envío para las recogidas realizadas en el punto de recogida
            habitual incluido en esta oferta.
          </li>
          <li class="pl-4">
            - Con un coste de {{ getAdditionalServiceById('INTERCITY_SUP').value }}
            <span class="euro-symbol">€</span>
            por envío con un mínimo de {{ getAdditionalServiceById('INTERCITY_SUP').minValue }}
            <span class="euro-symbol">€</span>
            hasta 10kg (+ {{ getAdditionalServiceById('INTERCITY_ADIC').value }}
            <span class="euro-symbol">€</span>
            por kg adicional) solo cuando el origen y el destino son diferentes al punto de recogida
            habitual indicado en esta oferta.Para recogidas múltiples, se tomará como base del
            cálculo de kilo adicional, la suma del peso de todos los bultos del total de los envíos.
          </li>
        </ul>
        <p class="body-2 justify-text body-2--bold mt-4 mb-0">
          Retornos y devoluciones.
        </p>
        <p class="body-2 justify-text mt-1 mb-0">
          Se aplicará la misma tarifa que la de emisión para todos los servicios retorno y devolución.
        </p>
        <p class="body-2 justify-text body-2--bold mt-4 mb-0">
          Canarias, Baleares, Andorra, Ceuta, Melilla, Gibraltar e Islas Portugal
        </p>
        <p class="body-2 justify-text mt-1 mb-0">
          La tarifa para los envíos entre las diferentes zonas, Islas Baleares, Canarias, Ceuta,
          Melilla, Gibraltar, Andorra e Islas Portugal, se calculará sumando las tarifas de servicio
          en las zonas de origen y destino.
        </p>
        <p class="body-2 justify-text mt-1 mb-0">
          Por ejemplo, para envíos con origen en Ceuta y destino en Andorra, sería:
          <br />
          Tarifa del servicio zona Ceuta + Tarifa del servicio zona Andorra.
        </p>

        <p class="body-2 justify-text body-2--bold mt-4 mb-0">
          Zoning. División del área geográfica para los servicios.
        </p>
        <ul class="list-style-none body-2 justify-text">
          <li class="pl-4">
            - Provincial: Se considera servicio Provincial aquel en el que los códigos postales de
            su origen y destino estén dentro de su misma provincia.
          </li>
          <li class="pl-4">
            - Regional: Se considera servicio Regional aquel en el que los códigos postales de
            origen estén dentro de la provincia de origen y el destino sea de la misma comunidad o
            provincia limítrofe a la de origen.
          </li>
          <li class="pl-4">
            - Peninsular: Se considera servicio Peninsular aquel en el que los códigos postales de
            origen estén dentro de la provincia de origen y el destino sea otra comunidad y el resto
            de las provincias no limítrofes a la de origen.
          </li>
          <li class="pl-4">
            - Peninsular+: Se considera servicio Peninsular+ aquel en el que entre la capital de
            provincia de origen y la capital de provincia de destino hay más de 800 km de distancia.
          </li>
          <li class="pl-4">
            - Portugal: Se considera servicio Portugal aquel en el que el código postal de origen o
            destino sea Portugal. Si el código postal de origen y el código postal de destino es
            Portugal, se considerará zona Peninsular.
          </li>
          <li class="pl-4 mt-1">
            Nota: Todos los envíos llevan incluida la entrega en más de 20.000 puntos Collectt Express (España y Portugal) <u>sin coste adicional</u>.
          </li>
        </ul>



      </div>

      <Footer logo :page="previousPages + 2" />
    </div>
    <div class="position-relative dinA4">
      <img :src="require('@/assets/other-considerations-header.png')" class="page__header" />
      <div class="page__container">

        <p class="body-2 justify-text body-2--bold mt-0 mb-0">Suplemento de Combustible</p>
        <p class="body-2 justify-text mt-1 mb-0">
          Esta tarifa está sujeta a suplemento por combustible. Este Suplemento se determinará en
          base a los precios oficiales del gasóleo publicados por el Ministerio para la Transición
          Ecológica https://energia.gob.es y se aplicará sobre los servicios de transporte. Podrá
          encontrar la tabla para la aplicación de este suplemento en www.cttexpress.com/suplementos.
        </p>

        <div class="d-flex mt-1 mb-0">
          <table v-for="(table, iTable) in fuelSupplementTable" :key="iTable" class="half-width">
            <tr class="dark-grey-background mb-0">
              <td colspan="2" class="body-2 color-white text-center pb-2">
                Precio litro
                <br />
                combustible diesel
              </td>
              <td class="body-2 color-white text-center pb-2">
                % suplemento
                <br />
                por
              </td>
            </tr>
            <tr class="dark-grey-background tr-collapsed">
              <td class="body-2 text-center color-white pb-2">Desde</td>
              <td class="body-2 color-white text-center pb-2">Hasta</td>
              <td class="body-2 color-white text-center pb-2">combustible</td>
            </tr>

            <tr v-for="(row, i) in table" :key="i">
              <td class="body-2 text-center">
                {{ row.from }}
                <span v-if="showEuroSymbol(row.from)" class="euro-symbol">€</span>
              </td>
              <td class="body-2 text-center">
                {{ row.to }}
                <span v-if="showEuroSymbol(row.to)" class="euro-symbol">€</span>
              </td>
              <td class="body-2 text-center">{{ row.value }} %</td>
            </tr>
          </table>
        </div>

        <p class="body-2 justify-text ml-2" v-if="showFuelText">
          Este suplemento tendrá una bonificación de un {{ fuelValue }}% durante los primeros
          {{ fuelExpirationMonths }} meses desde la firma del presente contrato.
        </p>

        <p class="body-2 justify-text body-2--bold mt-4 mb-0">
          Medios electrónicos para la solicitud de recogidas y documentación de envíos.
        </p>
        <p class="body-2 justify-text mt-1 mb-0">
          Esta tarifa está vinculada a la utilización de medios electrónicos que CTT Express pone a
          su disposición para la solicitud de recogidas y documentación de envíos. En caso de
          solicitar las recogidas por medios no electrónicos, o documentar los envíos con la
          utilización de albaranes manuales, CTT Express se reserva el derecho de incrementar su
          tarifa en 0,50
          <span class="euro-symbol">€</span>
          para cada uno de estos servicios.
        </p>

        <p class="body-2 justify-text body-2--bold mt-4 mb-0">Impuestos</p>
        <p class="body-2 justify-text mt-1 mb-0">
          La unidad monetaria de esta tarifa es el Euro (<span class="euro-symbol">€</span>). Esta
          tarifa no incluye impuestos tales como el IVA, IPSI, IGIC e IGI ni despachos aduaneros.
        </p>

        <p class="body-2 justify-text body-2--bold mt-4 mb-0">Validez de la Oferta</p>
        <p class="body-2 justify-text mt-1 mb-0">
          La presente oferta tendrá una validez de sesenta días (60) a contar desde la fecha del
          documento. Transcurrido el plazo sin que haya sido aceptada, quedará sin efecto.
        </p>
      </div>

      <Footer logo :page="previousPages + 3" />
    </div>
  </div>
</template>

<script>
import Footer from '@/containers/offer-form/sign-off/pdf-venta-directa-2025/Footer'
import { mapGetters } from 'vuex'
import { GET_OFFER_ITEM } from '@/store/modules/offer/getters'

export default {
  name: 'OtherConsiderations',
  components: { Footer },
  data() {
    return {
      fuelSupplementTable: {
        table1: [
          { from: '-', to: '0,949', value: '0,00' },
          { from: '0,950', to: '0,999', value: '1,50' },
          { from: '1,000', to: '1,049', value: '2,00' },
          { from: '1,050', to: '1,099', value: '2,50' },
          { from: '1,100', to: '1,149', value: '3,00' },
          { from: '1,150', to: '1,199', value: '3,50' },
          { from: '1,200', to: '1,249', value: '4,00' },
          { from: '1,250', to: '1,299', value: '4,50' },
          { from: '1,300', to: '1,349', value: '5,00' },
        ],
        table2: [
          { from: '1,350', to: '1,399', value: '5,50' },
          { from: '1,400', to: '1,449', value: '6,00' },
          { from: '1,450', to: '1,499', value: '6,50' },
          { from: '1,500', to: '1,549', value: '7,00' },
          { from: '1,550', to: '1,599', value: '7,50' },
          { from: '1,600', to: '1,649', value: '8,00' },
          { from: '1,650', to: '1,699', value: '8,50' },
          { from: '1,700', to: '1,749', value: '9,00' },
          { from: '1,750', to: '1,799', value: '9,50' },
        ],
        table3: [
          { from: '1,800', to: '1,849', value: '10,00' },
          { from: '1,850', to: '1,899', value: '10,50' },
          { from: '1,900', to: '1,949', value: '11,00' },
          { from: '1,950', to: '1,999', value: '11,50' },
          { from: '2,000', to: '2,049', value: '12,00' },
          { from: '2,050', to: '2,099', value: '12,50' },
          { from: '2,100', to: '2,149', value: '13,00' },
          { from: '2,150', to: '2,199', value: '13,50' },
          { from: '2,200', to: '≥ 2,249', value: '14,00' },
        ],
      },
      previousPages: 0,
    }
  },
  computed: {
    ...mapGetters('offer', [GET_OFFER_ITEM]),
    getFuelService() {
      return this[GET_OFFER_ITEM]('extraServicesList').find(service => service.id == "COMBUSTIBLE")
    },
    fuelValue() {
      return this.getFuelService?.value ?? 0
    },
    fuelExpirationMonths() {
      return this.getFuelService?.expireMonths ?? 0
    },
    showFuelText() {
      return this.fuelValue > 0 && this.fuelExpirationMonths > 0
    },
  },
  methods: {
    showEuroSymbol(value) {
      return value !== '-'
    },
    getAdditionalServiceById(id) {
      return this.$parent.getAdditionalServiceById(id)
    },
    getAdditionalServiceByDesc(desc) {
      return this.$parent.getAdditionalServiceByDesc(desc)
    },
  },
  mounted() {
    this.previousPages = this.$parent.sectionPreviousPages('OtherConsiderations')
  },
}
</script>
